export default __webpack_public_path__ + "static/media/Guru-Parampara-23.6754d81e.png";